import * as Sentry from "@sentry/tanstackstart-react";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export function reportError(error: unknown, context?: Record<string, unknown>): void {
  const message =
    error instanceof Error ? error.message : String(error ?? "Unknown error");
  const stack = error instanceof Error ? (error.stack ?? undefined) : undefined;

  // Always log to console for local debugging
  console.error("[AdKavi error]", message, context ?? "");

  // Send to Sentry (no-ops if VITE_SENTRY_DSN is not set)
  if (error instanceof Error) {
    Sentry.captureException(error, { extra: context });
  } else {
    Sentry.captureMessage(message, { level: "error", extra: context });
  }

  // Also write to Supabase error_logs as a belt-and-suspenders backup
  if (!supabaseUrl || !supabaseKey) return;
  fetch(`${supabaseUrl}/rest/v1/error_logs`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      apikey: supabaseKey,
      Authorization: `Bearer ${supabaseKey}`,
      Prefer: "return=minimal",
    },
    body: JSON.stringify({
      message,
      stack: stack ?? null,
      page_url: typeof window !== "undefined" ? window.location.href : null,
      context: context ?? null,
    }),
  }).catch(() => undefined);
}
